<template>
  <div>
    <Header></Header>
    <div class="contact">
      <div class="abous">联系我们</div>
      <div v-for="(list,index) in lists" :key="index">
        <div class="title">{{list.name}}</div>
        <div class="emall">{{list.number}}</div>
        <div class="henxian"></div>
      </div>
      <!-- <div v-for="(list1,index) in lists1" :key="index">
        <div class="title">{{list1.name}}</div>
        <div class="emall">{{list1.number}}</div>
        <div class="henxian"></div>
      </div>
      <div v-for="(list2,index) in lists2" :key="index">
        <div class="title">{{list2.name}}</div>
        <div class="emall">{{list2.number}}</div>
        <div class="emall">{{phone}}</div>
        <div class="henxian"></div>
      </div> -->
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "../header";
import Footer from "../footer";
export default {
  name: "",
  data() {
    return {
      lists: [],
      // lists1: [],
      // list2:[],
      // phone:""
    };
  },
  methods: {
    // 联系我们
    async aboutpc() {
      await this.$service.home
        .aboutpc({})
        .then(res => {
          console.log(res.data.content);
          if (res.data.code == 200) {
            this.lists=res.data.content;
            // this.lists1.push(res.data.content[1]);
            // this.lists2.push(res.data.content[2]);
            // this.phone=res.data.content[3].number;
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  components: {
    Header,
    Footer
  },
  mounted() {
    this.aboutpc();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.contact {
  width: 1200px;
  height: 710px;
  background: rgba(255, 255, 255, 1);
  border-radius: 3px;
  border: 1px solid rgba(237, 237, 237, 1);
  margin: 0 auto;
  margin-top: 16px;
  padding: 36px 0 0 36px;
}
.contact .abous {
  font-size: 22px;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  line-height: 30px;
  margin-bottom: 24px;
}
.contact .emall {
  font-size: 16px;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 26px;
  margin-bottom: 24px;
}
.contact .title {
  font-size: 18px;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  line-height: 25px;
  margin-bottom: 10px;
}
.contact .henxian {
  width: 709px;
  height: 1px;
  background: rgba(230, 230, 230, 1);
  margin-bottom: 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/contact/contact.vue